import { api } from '@/lib/api-manager'

export async function getUniquePreviousEducationalInstitutions(
  pageParam: number,
  term: string
) {
  const response = await api.get(
    'v1/educations/previous-educations/educational-institutions',
    {
      params: { pageParam, term }
    }
  )

  return response.data
}
